import {
  Body2,
  Display3,
  Grid,
  GridItem,
  Label1,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from '@sainsburys-tech/fable'
import React from 'react'

interface IProps {
  rawShelfLifeComments: string[]
}

const PossibleRowTitlesOrdered: string[] = [
  'Display Life',
  'Customer Life',
  'Total Life',
]

const QpigShelfLife = (props: IProps) => {
  let error = ''
  let columnTitles: string[] = ['']
  const rowTitles: string[] = []
  const rowsByColumn: string[][] = []
  const columnsByRow: string[][] = []

  if (!props.rawShelfLifeComments) {
    return <></>
  }

  const isKnownHeaderWithDash = (text: string) => {
    const formatText = text.trim().toLowerCase().toString()
    if (formatText === 'un-sliced loaf' || formatText === 'un-sliced') {
      return true
    }
    return false
  }

  const getSeparatorIndex = (text: string): number => {
    let separatorIndex = text.indexOf(':')
    if (separatorIndex === -1 && isKnownHeaderWithDash(text) === false) {
      separatorIndex = text.indexOf('-')
    }

    if (separatorIndex === -1) {
      separatorIndex = text.indexOf('=')
    }

    return separatorIndex
  }

  const getHeader = () => (
    <>
      <Display3
        className='c-qpig-step-title'
        data-testid='shelf-life-header'
        style={{ marginBottom: '16px', textAlign: 'left' }}
      >
        Shelf Life
      </Display3>
      <Body2 style={{ textAlign: 'left', paddingBottom: '16px' }}>
        Ensure that the product is merchandised correctly refer to the planogram
      </Body2>
    </>
  )

  props.rawShelfLifeComments.forEach((column) => {
    if (!column) {
      return
    }

    const rows: string[] = []

    const columnRows = column.split('\n')

    for (const row of columnRows) {
      if (row === '') {
        continue
      }
      const separatorIndex = getSeparatorIndex(row)

      if (separatorIndex === -1) {
        columnTitles.push(row.trim())
        continue
      }

      const rowTitle = row.substring(0, separatorIndex).trim()

      if (
        !PossibleRowTitlesOrdered.some(
          (title) => title.toUpperCase() === rowTitle.toUpperCase(),
        )
      ) {
        continue
      }

      if (
        !rowTitles.some(
          (title) =>
            title.toUpperCase() === rowTitle.toUpperCase().toUpperCase(),
        )
      ) {
        rowTitles.push(rowTitle)
      }

      rows.push(row)
    }

    rowsByColumn.push(rows.sort())
  })

  if (rowsByColumn.some((x) => x.length !== rowsByColumn[0].length)) {
    error = 'Not every column has the same number of rows'
  }

  if (columnTitles.length === 1) {
    columnTitles = []
  }

  if (error !== '') {
    return (
      <div className='c-qpig-step-section'>
        <h2 className='c-qpig-step-title'>Shelf Life - errors</h2>
        <p>{error}</p>
        {props.rawShelfLifeComments.map((rawShelfLifeComment, i) => (
          <p key={i}>{rawShelfLifeComment}</p>
        ))}
      </div>
    )
  }

  let rowIndex = -1
  PossibleRowTitlesOrdered.forEach((PossibleShelfLifeRowTitle) => {
    if (
      rowTitles.some(
        (title) =>
          title.toUpperCase() === PossibleShelfLifeRowTitle.toUpperCase(),
      )
    ) {
      rowIndex++
      columnsByRow.push([PossibleShelfLifeRowTitle])
      rowsByColumn.forEach((columnRows) => {
        columnRows.forEach((columnRow) => {
          const separatorIndex = getSeparatorIndex(columnRow)
          if (
            columnRow.substring(0, separatorIndex).toUpperCase().trim() ===
            PossibleShelfLifeRowTitle.toUpperCase()
          ) {
            const rowValue = columnRow
              .substring(separatorIndex + 1, columnRow.length)
              .trim()
            columnsByRow[rowIndex].push(rowValue)
          }
        })
      })
    }
  })

  const getQpigTable = (isResponsive: boolean) => {
    const colSpan = isResponsive
      ? 12
      : columnTitles.length === 0
        ? { sm: 6, md: 4, lg: 4 }
        : 8

    return (
      <div className='c-qpig-table-fixed-width'>
        <Grid>
          <GridItem colSpan={colSpan}>
            <Table className='c-qpig-border-line'>
              <TableHeader>
                <TableRow
                  data-testid={isResponsive ? 'shelf-life-header-row' : ''}
                >
                  {columnTitles.map((columnTitle, colNumber) => (
                    <TableCell key={colNumber}>{columnTitle}</TableCell>
                  ))}
                </TableRow>
              </TableHeader>
              <TableBody>
                {columnsByRow.map((row, rowNumber) => (
                  <TableRow
                    data-testid={
                      isResponsive ? `shelf-life-row-${rowNumber}` : ''
                    }
                    key={rowNumber}
                  >
                    {row.map((cell, cellNumber) => (
                      <TableCell
                        aria-label={columnTitles[cellNumber]}
                        key={`${rowNumber}_${cellNumber}`}
                      >
                        {cellNumber === 0 ? (
                          <Label1>{cell}</Label1>
                        ) : (
                          <Body2>{cell}</Body2>
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </GridItem>
        </Grid>
      </div>
    )
  }

  return (
    <div className='c-qpig-main-content'>
      {getHeader()}
      <div className='c-table-responsive'>
        <div className='c-table-responsive__mobile'>{getQpigTable(true)}</div>
        <div className='c-table-responsive__desktop'>{getQpigTable(false)}</div>
      </div>
    </div>
  )
}

export default QpigShelfLife
